// extracted by mini-css-extract-plugin
export default {"topsection":"TopSection_topsection__gIUcV","main__title":"TopSection_main__title__7qaqB","main__text":"TopSection_main__text__ZMZH1","container":"TopSection_container__CQKQ7"};